import { render, staticRenderFns } from "./multiple-delete-demo-req-popup.html?vue&type=template&id=3b530925&scoped=true&external"
import script from "./multiple-delete-demo-req-popup.js?vue&type=script&lang=js&external"
export * from "./multiple-delete-demo-req-popup.js?vue&type=script&lang=js&external"
import style0 from "./multiple-delete-demo-req-popup.scss?vue&type=style&index=0&id=3b530925&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b530925",
  null
  
)

export default component.exports